import { useState, useEffect, CSSProperties } from "react"
import Layout from "../../Layout"
import { useSelector } from "react-redux"
import { requestTarjetaVistas } from "../../actions/admin"
import AdminCards from "Components/AdminCards"

import {
  AdminElementBanner,
  AdminElementBannerTitle,
  AdminElementContainer,
} from "./styled.components"

import "../../assets/css/admin/index.css"

const Admin = () => {
  const [tarjetaVistas, setTarjetavistas] = useState([])

  const { bannerAdmin } = useSelector((state: any) => state.theme)
  const { catalogs } = useSelector((state: any) => state.theme)
  const { context } = useSelector((state: any) => state.theme)
  const { modo } = useSelector((state: any) => state.user)

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: context?.background,
  }

  const handleTarjetaVistas = async () => {
    const tarjetaVistas = await requestTarjetaVistas()
    let items: any = []
    if (tarjetaVistas) {
      items = tarjetaVistas.map((tarjetaVista: any) => {
        let itemStyles = JSON.parse(tarjetaVista.estilo)
        const buttons: any = tarjetaVista.elementos
          .filter((element: any) => element.tipoElemento === "Botón")
          .map((element: any) => {
            return {
              id: element.idTarjetaDet,
              text: element.descDetalle,
              module: element.url,
              url: element.rutaReporte,
              style: { ...context, contentColor: itemStyles?.contentColor },
            }
          })
        const scores: any = tarjetaVista.elementos
          .filter((element: any) => element.tipoElemento === "Contador")
          .map((element: any) => {
            return {
              id: element.idTarjetaDet,
              text: element.descDetalle,
              value: element.valor,
              style: { ...context, contentColor: itemStyles?.contentColor },
            }
          })
        return {
          id: tarjetaVista.idVista,
          icon: "star", //tarjetaVista.imagen,
          style: { ...context, contentColor: itemStyles?.contentColor },
          title: tarjetaVista.tarjeta,
          buttons: buttons,
          scores: scores,
        }
      })
    }
    setTarjetavistas(items)
  }

  useEffect(() => {
    handleTarjetaVistas()
  }, [])

  return (
    <Layout theme={styles}>
      <div className={"admin-container"}>
        <AdminElementBanner
          bgImagen={
            bannerAdmin
              ? `${process.env.PUBLIC_URL}${bannerAdmin}`
              : "/commons/bg_profile.png"
          }>
          <AdminElementBannerTitle textColor={catalogs?.textTitleColor} >Administración</AdminElementBannerTitle>
        </AdminElementBanner>
        <AdminElementContainer bg={context?.background}>
          <AdminCards dataCards={tarjetaVistas} />
        </AdminElementContainer>
      </div>
    </Layout>
  )
}

export default Admin
